module.exports = __webpack_public_path__ + "static/img/web_phone_mobile.0411abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appRecommend/web_phone_mobile.png
// module id = FLSz
// module chunks = 1